//for live

// export const IP = "164.100.221.31";

export const IP = "api.nicdc.in"

export const PROTOCOL = "https"

///for local
// export const IP = "192.168.1.75:8000"
// export const PROTOCOL = "http";

export const ProjectMicroService = `${PROTOCOL}://${IP}/api/projects`;
export const MediaMicroService = `${PROTOCOL}://${IP}/api/media`;
export const TenderMicroService = `${PROTOCOL}://${IP}/api/tender`;
export const CorridorMicroService = `${PROTOCOL}://${IP}/api/corridor`;
export const NodeMicroService = `${PROTOCOL}://${IP}/api/node`;
export const ContactMicroService = `${PROTOCOL}://${IP}/api/contactus`;
export const jobMicroService = `${PROTOCOL}://${IP}/api/jobs`;
export const careerMicroService = `${PROTOCOL}://${IP}/api/careers`;

export const getMediaResources = MediaMicroService + "get";
export const getProject = ProjectMicroService + "/get";
export const getTender = TenderMicroService + "/get";
export const getCorridor = CorridorMicroService + "/get";
export const getNode = NodeMicroService + "/get";
export const getContact = ContactMicroService + "/get";
export const addContact = ContactMicroService + "/submitForm";

export const getMedia = MediaMicroService + "/get";
export const addJob = jobMicroService + "/add";
export const getCareer = careerMicroService + "/get";

export const FileUploadUrl = `${PROTOCOL}://${IP}/upload/`;

export const LastUpdated = '25th June 2025'

